import type { OperationState, PlatformOperation } from '@/services/platform/platform.http'

export const ACTIVE_OPERATION_STATES: OperationState[] = ['requested', 'pending_approval', 'approved', 'preflight', 'executing', 'observing']

export function operationNeedsPolling(items: PlatformOperation[]): boolean {
  return items.some((item) => ACTIVE_OPERATION_STATES.includes(item.state))
}

export function operationTone(state: OperationState): string {
  if (state === 'succeeded') return 'text-green-700 bg-green-50'
  if (state === 'failed' || state === 'rejected') return 'text-red-700 bg-red-50'
  if (state === 'unknown') return 'text-amber-800 bg-amber-50'
  return 'text-blue-700 bg-blue-50'
}
